import Layout from "../layouts/LayoutDefault.jsx";
import ContentContainer from "../components/ContentContainer";
import MainContainer from "../components/MainContainer";
import SmallTitleText from "../components/SmallTitleText";
import EditOrganizerForm from "../components/loggedin/EditOrganizerForm";

const AddAndEditOrganizer = () => {
  return (
    <Layout
      title="Redigera arrangör"
      description="Uppdatera information för din arrangörsprofil"
    >
      <MainContainer>
        <ContentContainer>
          <div className="flex justify-between">
            <SmallTitleText text="Redigera arrangör" />
            <a href="/userprofile">
              <button className="btn btn-neutral border border-base-content/20">
                Tillbaka
              </button>
            </a>
          </div>

          <p className="my-4 max-w-2xl">
            Här kan du uppdatera information om arrangören, till exempel namn,
            slug, kontaktuppgifter och beskrivning.
          </p>

          <div className="bg-base-200 border border-base-content/20 rounded-lg p-2 mt-2">
            <EditOrganizerForm />
          </div>
        </ContentContainer>
      </MainContainer>
    </Layout>
  );
};

export default AddAndEditOrganizer;
